import type { Subject, Department } from '../types/wizard';
import { requiresDepartment } from '../types/wizard';

const hscPhysics: Subject = {
  id: 'hsc-physics',
  name: 'HSC Physics',
  code: 'PHY',
  papers: [
    {
      id: 'physics-paper-1',
      name: '1st Paper',
      chapters: [
        {
          id: 'physics-1-ch-1',
          name: 'Physical World and Measurement',
          banglaName: 'ভৌত জগৎ ও পরিমাপ',
        },
        {
          id: 'physics-1-ch-2',
          name: 'Vector',
          banglaName: 'ভেক্টর',
        },
        {
          id: 'physics-1-ch-3',
          name: 'Dynamics',
          banglaName: 'গতিবিদ্যা',
        },
        {
          id: 'physics-1-ch-4',
          name: 'Newtonian Mechanics',
          banglaName: 'নিউটনিয়ান বলবিদ্যা',
        },
        {
          id: 'physics-1-ch-5',
          name: 'Work, Energy, and Power',
          banglaName: 'কাজ, শক্তি ও ক্ষমতা',
        },
        {
          id: 'physics-1-ch-6',
          name: 'Gravitation and Gravity',
          banglaName: 'মহাকর্ষ ও অভিকর্ষ',
        },
        {
          id: 'physics-1-ch-7',
          name: 'Properties of Matter',
          banglaName: 'পদার্থের গাঠনিক ধর্ম',
        },
        {
          id: 'physics-1-ch-8',
          name: 'Periodic Motion',
          banglaName: 'পর্যাবৃত্তিক গতি',
        },
        {
          id: 'physics-1-ch-9',
          name: 'Waves',
          banglaName: 'তরঙ্গ',
        },
        {
          id: 'physics-1-ch-10',
          name: 'Ideal Gas and Gas Laws',
          banglaName: 'আদর্শ গ্যাস ও গ্যাসের গতিতত্ত্ব',
        },
      ],
    },
    {
      id: 'physics-paper-2',
      name: '2nd Paper',
      chapters: [
        {
          id: 'physics-2-ch-1',
          name: 'Thermodynamics',
          banglaName: 'তাপগতিবিদ্যা',
        },
        {
          id: 'physics-2-ch-2',
          name: 'Static Electricity',
          banglaName: 'স্থির তড়িৎ',
        },
        {
          id: 'physics-2-ch-3',
          name: 'Current Electricity',
          banglaName: 'চল তড়িৎ',
        },
        {
          id: 'physics-2-ch-4',
          name: 'Magnetic Effects of Electric Current',
          banglaName: 'চল তড়িৎের চৌম্বক ক্রিয়া',
        },
        {
          id: 'physics-2-ch-5',
          name: 'Electromagnetic Induction and AC',
          banglaName: 'তড়িৎচৌম্বক আবেশ ও পরিবর্তী তড়িৎ',
        },
        {
          id: 'physics-2-ch-6',
          name: 'Geometrical Optics',
          banglaName: 'জ্যামিতিক আলোকবিজ্ঞান',
        },
        {
          id: 'physics-2-ch-7',
          name: 'Physical Optics',
          banglaName: 'ভৌত আলোকবিজ্ঞান',
        },
        {
          id: 'physics-2-ch-8',
          name: 'Modern Physics',
          banglaName: 'আধুনিক পদার্থবিজ্ঞান',
        },
        {
          id: 'physics-2-ch-9',
          name: 'Atomic Model and Nuclear Physics',
          banglaName: 'পরমাণুর মডেল ও নিউক্লিয় পদার্থবিজ্ঞান',
        },
        {
          id: 'physics-2-ch-10',
          name: 'Semiconductor and Electronics',
          banglaName: 'অর্ধপরিবাহী ও ইলেকট্রনিক্স',
        },
      ],
    },
  ],
} as Subject;

export const sscSubjectsByDepartment: Record<Department, Subject[]> = {
  science: [],
  commerce: [],
  arts: [],
};

export const hscSubjectsByDepartment: Record<Department, Subject[]> = {
  science: [hscPhysics],
  commerce: [],
  arts: [],
};

export function getSubjects(classNum: number | null, department: Department | null): Subject[] {
  if (!classNum || !requiresDepartment(classNum)) return [];
  if (!department) return [];
  return classNum <= 10
    ? (sscSubjectsByDepartment[department] ?? [])
    : (hscSubjectsByDepartment[department] ?? []);
}
